"use strict";

import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
let baseUrl = process.env.VUE_APP_BASE_URL
let timeOut = process.env.VUE_APP_TIMEOUT

let config = {
  baseURL: baseUrl,
  timeout: timeOut
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    if (process.env.NODE_ENV === 'development') {
      console.error(error)
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  response => {
    // return res
    if (process.env.NODE_ENV === 'development') {
      console.info('[UI Framework api res] ' + response.config.url + '\n%cresponse:', 'background-color:#fd9494; color:black', response.data)
    }
    return response
  },
  error => {
    // error.response가 없을 경우도 존재 - Network 문제
    if (error.response) {
      if (process.env.NODE_ENV === 'development') {
        console.info('[UI Framework api res] ' + error.config.url + '\n%c(error)response:', 'background-color:#fd9494; color:black', error.response.data)
      }

      if (error.response.status === 503) {
        error.response.data = {
          res_code: '503',
          res_msg_ar: 'Service Temporarily Unavailable!',
          res_msg_en: 'Service Temporarily Unavailable!'
        }
      }

      return error.response
    // Network 관련 문제 발생 시 error.response가 없음.
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.info('%cerror : ', 'background-color:#fd9494; color:black', JSON.parse(JSON.stringify(error)))
      }

      error.response = {
        status: 408,
        data: {
          res_code: error.code === 'ECONNABORTED' ? '408' : (error.code) ? error.code : '406',
          res_msg_ar: error.message,
          res_msg_en: error.message
        }
      }
    }

    if (process.env.NODE_ENV === 'development') {
      console.info('%cerror code : ', 'background-color:#fd9494; color:black', error.response.data.res_code)
      console.info('%cerror description ar : ', 'background-color:#fd9494; color:black', error.response.data.res_msg_ar)
      console.info('%cerror description en : ', 'background-color:#fd9494; color:black', error.response.data.res_msg_en)
    }

    return Promise.reject(error.response)
  }
)

export default _axios
